export default __webpack_public_path__ + "static/media/udemy.f7080759.svg";